// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — dates-select.styled.classic.js, новая — dates-select.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './dates-select.styled.classic';
import * as cp from './dates-select.styled.cp';

export const CalendarInterval = isCp ? cp.CalendarInterval : classic.CalendarInterval;
